import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  ENVIRONMENT,
  EnvironmentModel,
} from '@lyceo/lyceo-pupil-app/shared/util-environment';

import { Injectable, inject } from '@angular/core';
import {
  BookProgressResponseDto,
  UpdateBookProgress,
} from './+state/book-progress/book-progress.model';
import { BookDto } from './+state/book/book.model';
@Injectable({
  providedIn: 'root',
})
export class BookService {
  private readonly environment: EnvironmentModel =
    inject<EnvironmentModel>(ENVIRONMENT);
  private readonly http: HttpClient = inject(HttpClient);

  public getBook(id: string): Observable<BookDto> {
    const url: string = `${this.environment.biebApiUrl}/api/v3/books/${id}`;
    const headersToSend: HttpHeaders = new HttpHeaders().set(
      'Accept',
      'application/json',
    );
    return this.http.get<BookDto>(url, {
      headers: headersToSend,
    });
  }

  public getBookProgress(id: string): Observable<BookProgressResponseDto> {
    const url: string = `${this.environment.practiceApiUrl}/api/books/${id}/progress`;
    const headersToSend: HttpHeaders = new HttpHeaders().set(
      'Accept',
      'application/json',
    );
    return this.http.get<BookProgressResponseDto>(url, {
      headers: headersToSend,
    });
  }

  public patchBookProgress(
    id: string,
    body: UpdateBookProgress,
  ): Observable<BookProgressResponseDto> {
    const url: string = `${this.environment.practiceApiUrl}/api/books/${id}/progress`;
    const headersToSend: HttpHeaders = new HttpHeaders()
      .set('Accept', 'application/json')
      .set('Content-Type', 'application/merge-patch+json');
    return this.http.patch<BookProgressResponseDto>(url, body, {
      headers: headersToSend,
    });
  }
}
